import React, { Component } from 'react'
import { Collapse, Button } from 'hljd'
import style from '../style.module.less'
import { observer } from 'mobx-react'
import Content from '../Content'
import Mode from '../Mode'
import Range from '../Range'
const Panel = Collapse.Panel
const customPanelStyle = {
  background: '#ebf3ff',
  marginBottom: 24,
  overflow: 'hidden',
  border: '1px solid transparent'
}
@observer
export default class extends Component {
  getHeader = (name, key, content, num) => {
    const { store } = this.props
    const { activePanel, saveParams } = store
    const header = (
      <div className={style.header}>
        <div className={style.txt}>
          {name}
          {activePanel != key && num && `（${num}）`}
          <i className="arrow_icon" />
        </div>
        {activePanel == key ? (
          <Button onClick={saveParams(key)}>保存</Button>
        ) : (
          <span>{content && content.join('+')}</span>
        )}
      </div>
    )
    return header
  }
  render() {
    const { store } = this.props
    const {
      activePanel,
      changePanel,
      userRangeTxt,
      sendModeTxt,
      selectedRowKeys
    } = store
    return (
      <div className={style.bd}>
        <Collapse accordion activeKey={activePanel} onChange={changePanel}>
          <Panel
            header={this.getHeader(
              `1.人员范围`,
              'range',
              userRangeTxt,
              selectedRowKeys.length
            )}
            key="range"
            style={customPanelStyle}
            showArrow={false}
          >
            <Range store={store} />
          </Panel>
          <Panel
            header={this.getHeader(`2.发送方式`, 'sendMode', sendModeTxt)}
            key="sendMode"
            style={customPanelStyle}
            showArrow={false}
          >
            <Mode store={store} />
          </Panel>
          <Panel
            header={this.getHeader(`3.详细内容`, 'content')}
            key="content"
            style={customPanelStyle}
            showArrow={false}
          >
            <Content store={store} />
          </Panel>
        </Collapse>
      </div>
    )
  }
}
